import React from 'react'
import { Button, Spacer, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { useRemovePage } from 'src/graphql/hooks'

const PageDeleteConfirm = ({
   onCancelButtonClick,
   onDelete,
   pageId,
   pageTitle
}) => {
   const { removePage, mutating } = useRemovePage()

   const handleDeletePage = async () => {
      await removePage({ id: pageId })

      if (onDelete) {
         onDelete()
      }
   }

   return (
      <View>
         <View
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            padding="18px"
            borderBottom="1px solid #eee">
            <Text size="3" weight="medium">
               Confirm Deletion
            </Text>
         </View>
         <View padding="18px" textAlign="center">
            <View>
               <Text size="2" color="#444">
                  Are you sure you want to delete&nbsp;
                  <b>{pageTitle}</b>
                  ? This action cannot be undone.
               </Text>
               <Spacer size="2" />
            </View>
            <Spacer size="3" />
            <View display="flex" justifyContent="flex-end">
               <Button
                  onClick={onCancelButtonClick}
                  width="50%"
                  size="sm"
                  name="Cancel"
                  color="#fff"
                  textColor="#666"
               />
               <Button
                  onClick={handleDeletePage}
                  width="50%"
                  size="sm"
                  type="submit"
                  name="Delete"
                  color="#ee5248"
                  textColor="#fff"
                  mode={mutating ? 'loading' : 'normal'}
               />
            </View>
         </View>
      </View>
   )
}

PageDeleteConfirm.propTypes = {
   onCancelButtonClick: PropTypes.func.isRequired,
   onDelete: PropTypes.func.isRequired,
   pageId: PropTypes.string.isRequired,
   pageTitle: PropTypes.string.isRequired
}

export default PageDeleteConfirm
